import React from 'react';
import './ProductSection.css';

const ProductSection = () => {
  const products = [
    {
      title: 'Product A',
      features: ['Feature 1', 'Feature 2', 'Feature 3']
    },
    {
      title: 'Product B',
      features: ['Feature 1', 'Feature 2', 'Feature 3']
    },
    {
      title: 'Product C',
      features: ['Feature 1', 'Feature 2', 'Feature 3']
    },
    {
      title: 'Product D',
      features: ['Feature 1', 'Feature 2', 'Feature 3']
    }
  ];

  return (
    <section className="product-section">
      <div className="container">
        <h2 className="section-title">Premium Interior Products</h2>
        <p className="section-description">
          Discover our curated collection of premium interior solutions designed 
          to elevate your space with style and functionality.
        </p>
        <div className="product-grid">
          {products.map((product, index) => (
            <div key={index} className="product-card">
              <h3 className="product-title">{product.title}</h3>
              <ul className="product-features">
                {product.features.map((feature, idx) => (
                  <li key={idx}>{feature}</li>
                ))}
              </ul>
              <button className="product-btn">Explore</button>
            </div>
          ))}
        </div>
        <div className="scroll-indicator">
          <div className="scroll-arrow">↓</div>
        </div>
      </div>
    </section>
  );
};

export default ProductSection;

